import gql from "graphql-tag";

export default gql`
  mutation ResolveManualOperation(
    $manualOperationId: Int!,
    $params: ResolveManualOperationParams!
  ){
    resolveManualOperation(
      id: $manualOperationId,
      params: $params
    ) {
      id
    }
  }
`;
